<template>
  <div ref="content" class="col-12 col-md-11 col-lg-10 col-xl-8 p-2 pt-5 p-sm-5 mx-auto mt-3 mt-sm-5 cert-page-content">
    <div class="cert-article px-2 px-sm-4">
      <h3 class="mb-4">DDoS Attack</h3>
      <p>
        A DDoS attack is a malicious attempt to disrupt the normal traffic of a targeted server, service or network by
        overwhelming the target or its surrounding infrastructure with a flood of Internet traffic.
      </p>

      <h4 class="mt-5 mb-4">How does a DDoS attack work ?</h4>
      <p>
        DDoS attacks are carried out using a network of machines connected to the Internet. These networks consist of
        malware-infected computers and other devices that allow attackers to control them remotely. These individual
        devices are called bots (or zombies) and groups of bots are called botnets. Once a botnet is established,
        attackers can send remote commands to each bot to launch attacks.
      </p>

      <h4 class="mt-5 mb-4">Types of DDoS Attacks</h4>
      <ul>
        <li>Volume-Based or Volume Metric Attacks</li>
        <li>Protocol Attacks</li>
        <li>Application Layer Attacks</li>
      </ul>

      <h4 class="mt-5 mb-4">DDoS Mitigation</h4>
      <p>
        If a suspected attack is in progress, an organization has several options to mitigate its impact.
      </p>
      <ul>
        <li>Conduct regular risk Assessments</li>
        <li>Traffic Differentiation by identifying the quality or source of the anomalous traffic.</li>
        <li>Black Hole Routing by creating a black hole route and pushes traffic down that black hole</li>
        <li>Rate Limiting by limiting the number of requests a server can accept in a given time period</li>
        <li>Use and protect your firewalls</li>
        <li>Use any of the DDoS Protection Solutions</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "GuideIncident"
}
</script>
